export default __webpack_public_path__ + "static/media/icon_mailto.4e3328ee.svg";